<template>
<header id="header" class="page-header sticky bg-white box-shadow animate fadeInDown">
  <div class="navbar navbar-expand-lg" >
    <!-- btn to toggle sidenav on small screen -->
    <a class="d-lg-none i-con-h-a px-1" data-toggle="modal" data-target="#aside">
      <i class="i-con i-con-menu text-muted"></i>
    </a>
    <!-- brand -->
    <a href="/" class="navbar-brand">
      <img src="@/assets/logo_2026.svg" width="50px" :alt="$t('message.title')">
      <span class="hidden-folded d-inline l-s-n-1x ">{{ $t('message.title') }}</span>
    </a>
    <!-- / brand -->
  
    <!-- Navbar collapse
    <div class="collapse navbar-collapse order-2 order-lg-1" id="navbarToggler">
      <ul class="navbar-nav mx-auto" data-nav>
        <li class="nav-item">
          <a href="../html/card.admin.html" class="nav-link">
            <span class="nav-text">Admin</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="../html/card.news.html" class="nav-link">
            <span class="nav-text">News</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="../html/card.music.html" class="nav-link">
            <span class="nav-text">Music &amp; Video</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="../html/card.social.html" class="nav-link">
            <span class="nav-text">Social</span>
          </a>
        </li>
      </ul>
      <form class="input-group m-2 my-lg-0 i-con-h-a ">
          <span class="input-group-prepend">
            <button type="button" class="btn no-shadow no-bg px-0"><i class="i-con i-con-search text-fade w-16"></i></button>
          </span>
          <input type="text" class="form-control no-border no-shadow no-bg typeahead" placeholder="Search..." data-plugin="typeahead">
      </form>
    </div> -->
  
    <ul class="nav navbar-menu order-1 order-lg-2">
      <!-- User dropdown menu -->
      <li class="nav-item dropdown">
        <a href="#" data-toggle="dropdown" class="nav-link d-flex align-items-center py-0 px-lg-0 px-2 text-color">
          <span class=" mx-2 d-none l-h-1x d-lg-block text-right">
              <small class='text-fade d-block mb-1'>{{ $t("message.Top.helloWelcome") }}</small>
            <span>{{ getUserData.first_name }} {{ getUserData.last_name }}</span>
          </span>
          <span class="avatar w-36">
            <img src="@/assets/Agile/assets/img/a0.jpg" alt="...">
          </span>
        </a>
        <div class="dropdown-menu dropdown-menu-right w pt-0 mt-3 animate fadeIn">
          <router-link class="dropdown-item" to="/profile">
            <span>{{ $t("message.Top.profile") }}</span>
          </router-link>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="logout.html" @click.prevent="logout">{{ $t("message.Top.signOut") }}</a>
        </div>
      </li>
    </ul>
  </div>
</header>
</template>


<script>
import { AUTH_LOGOUT } from '@/store/actions/auth'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'navigation-top',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'getUserData',
    ])
  },
  mounted () {

  },
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.go('/login'))
    }
  }
}
</script>

<style scoped lang="scss">
</style>

